(function () {
  if (window.ProductSwatches) return;

  var initializedSliders = new WeakSet();
  var layouts = new Map();
  var pendingLayouts = new Set();
  var layoutFrame = null;

  function scheduleLayout(slider) {
    pendingLayouts.add(slider);
    if (layoutFrame !== null) return;
    layoutFrame = window.requestAnimationFrame(function () {
      layoutFrame = null;
      layouts.forEach(function (_layout, element) {
        if (!element.isConnected) layouts.delete(element);
      });
      var updates = Array.from(pendingLayouts).map(function (element) {
        return element.isConnected ? layouts.get(element) : null;
      }).filter(Boolean);
      pendingLayouts.clear();
      // Measure all expanded groups together, then all collapsed scrollers together.
      ['prepare', 'measure', 'apply', 'measureScroll', 'applyScroll'].forEach(function (phase) {
        updates.forEach(function (layout) { layout[phase](); });
      });
    });
  }

  window.addEventListener('resize', function () {
    layouts.forEach(function (_layout, slider) { scheduleLayout(slider); });
  });

  function isDesktopSwatchLayout() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function centerActive(slider) {
    if (!slider) return;

    var active = slider.querySelector('.product-swatch.active-swatch');
    if (!active) return;

    var tile = active.closest('product-swatch') || active;
    var targetScroll = tile.offsetLeft - (slider.clientWidth / 2 - tile.clientWidth / 2);
    slider.scrollLeft = Math.max(targetScroll, 0);
  }

  function initSlider(slider) {
    if (!slider || initializedSliders.has(slider)) return;

    var group = slider.closest('[data-swatch-slider-group]');
    var track = group ? group.querySelector('[data-swatch-slider-track], .swatch-slider-track') : null;
    var thumb = track ? track.querySelector('.swatch-slider-thumb') : null;

    if (!group || !track || !thumb) return;

    initializedSliders.add(slider);

    var toggleButton = group.querySelector('[data-swatch-layout-toggle]');
    var prevNavButton = group.querySelector('[data-swatch-nav="prev"]');
    var nextNavButton = group.querySelector('[data-swatch-nav="next"]');
    var detailsEl = group.hasAttribute('data-addon-swatch-group') ? group.querySelector('details') : null;
    var summaryEl = detailsEl ? detailsEl.querySelector('summary') : null;
    var defaultCollapsed = group.hasAttribute('data-desktop-slider-default')
      ? group.getAttribute('data-desktop-slider-default') === 'true'
      : group.classList.contains('is-collapsed');
    var userPreferredCollapsed = null;
    var activePointerId = null;
    var pointerGrabOffset = 0;

    function getScrollMetrics() {
      var maxScroll = Math.max(slider.scrollWidth - slider.clientWidth, 0);
      var trackWidth = track.clientWidth || 0;
      var thumbWidth = trackWidth;

      if (slider.scrollWidth > 0) {
        thumbWidth = trackWidth * (slider.clientWidth / slider.scrollWidth);
      }

      thumbWidth = Math.min(trackWidth, Math.max(Math.min(40, trackWidth), thumbWidth));

      return {
        maxScroll: maxScroll,
        trackWidth: trackWidth,
        thumbWidth: thumbWidth,
        maxOffset: Math.max(trackWidth - thumbWidth, 0),
      };
    }

    function updateThumb(measuredMetrics) {
      var metrics = measuredMetrics && typeof measuredMetrics.maxScroll === 'number' ? measuredMetrics : getScrollMetrics();
      var scrollable = metrics.maxScroll > 1 && metrics.trackWidth > 0;

      thumb.style.display = scrollable ? '' : 'none';
      track.setAttribute('aria-disabled', scrollable ? 'false' : 'true');

      if (!scrollable) {
        track.setAttribute('aria-valuenow', '0');
        return;
      }

      var scrollRatio = Math.max(0, Math.min(slider.scrollLeft / metrics.maxScroll, 1));
      thumb.style.width = metrics.thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + metrics.maxOffset * scrollRatio + 'px)';
      track.setAttribute('aria-valuenow', Math.round(scrollRatio * 100).toString());
    }

    function setScrollFromPointer(clientX) {
      var metrics = getScrollMetrics();
      if (metrics.maxScroll <= 0 || metrics.maxOffset <= 0) return;

      var trackRect = track.getBoundingClientRect();
      var requestedOffset = clientX - trackRect.left - pointerGrabOffset;
      var thumbOffset = Math.max(0, Math.min(requestedOffset, metrics.maxOffset));
      slider.scrollLeft = (thumbOffset / metrics.maxOffset) * metrics.maxScroll;
    }

    function endTrackDrag(event) {
      if (activePointerId === null || (event && event.pointerId !== activePointerId)) return;

      if (track.hasPointerCapture && track.hasPointerCapture(activePointerId)) {
        track.releasePointerCapture(activePointerId);
      }

      activePointerId = null;
      track.classList.remove('is-dragging');
    }

    function measureWrappedRows() {
      if (!isDesktopSwatchLayout()) return false;

      var visibleChildren = Array.from(slider.children).filter(function (child) {
        return child.offsetParent !== null;
      });
      var firstTop = null;
      var wrapped = visibleChildren.some(function (child) {
        var top = Math.round(child.offsetTop);
        if (firstTop === null) {
          firstTop = top;
          return false;
        }
        return Math.abs(top - firstTop) > 4;
      });

      return wrapped;
    }

    function updateDesktopNavState(measuredMaxScroll) {
      if (!prevNavButton || !nextNavButton) return;

      var collapsed = isDesktopSwatchLayout() && group.classList.contains('is-collapsed');
      var maxScroll = typeof measuredMaxScroll === 'number' ? measuredMaxScroll : slider.scrollWidth - slider.clientWidth;
      var scrollable = collapsed && maxScroll > 4;
      var canScrollLeft = scrollable && slider.scrollLeft > 4;
      var canScrollRight = scrollable && slider.scrollLeft < maxScroll - 4;

      group.classList.toggle('can-scroll-left', canScrollLeft);
      group.classList.toggle('can-scroll-right', canScrollRight);
      prevNavButton.hidden = !canScrollLeft;
      nextNavButton.hidden = !canScrollRight;
    }

    var canCollapse = false;
    var scrollState = null;

    function applyDesktopLayoutState() {
      group.classList.toggle('has-layout-toggle', canCollapse);

      if (toggleButton) {
        toggleButton.hidden = !canCollapse;
        toggleButton.classList.toggle('is-visible', canCollapse);
      }

      if (!canCollapse) {
        group.classList.remove('is-collapsed');
      } else if (userPreferredCollapsed !== null) {
        group.classList.toggle('is-collapsed', userPreferredCollapsed);
      } else {
        group.classList.toggle('is-collapsed', defaultCollapsed);
      }

      if (toggleButton) {
        var expanded = !group.classList.contains('is-collapsed');
        toggleButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggleButton.setAttribute(
          'aria-label',
          expanded ? 'Collapse options into horizontal scroller' : 'Expand options into multi-row layout',
        );
      }
    }

    layouts.set(slider, {
      prepare: function () {
        if (detailsEl && isDesktopSwatchLayout()) detailsEl.open = true;
        if (isDesktopSwatchLayout()) group.classList.remove('is-collapsed');
      },
      measure: function () { canCollapse = measureWrappedRows(); },
      apply: applyDesktopLayoutState,
      measureScroll: function () {
        var active = slider.querySelector('.product-swatch.active-swatch');
        var tile = active && (active.closest('product-swatch') || active);
        var center = !isDesktopSwatchLayout() || group.classList.contains('is-collapsed');
        scrollState = {
          left: center && tile ? Math.max(tile.offsetLeft - (slider.clientWidth - tile.clientWidth) / 2, 0) : 0,
          metrics: getScrollMetrics(),
        };
      },
      applyScroll: function () {
        slider.scrollLeft = Math.min(scrollState.left, scrollState.metrics.maxScroll);
        updateThumb(scrollState.metrics);
        updateDesktopNavState(scrollState.metrics.maxScroll);
      },
    });

    function updateDesktopLayoutState() { scheduleLayout(slider); }

    slider.addEventListener('scroll', updateThumb, { passive: true });
    slider.addEventListener('scroll', updateDesktopNavState, { passive: true });

    track.addEventListener('pointerdown', function (event) {
      if (isDesktopSwatchLayout()) return;

      var metrics = getScrollMetrics();
      if (metrics.maxScroll <= 0) return;

      event.preventDefault();
      activePointerId = event.pointerId;

      var thumbRect = thumb.getBoundingClientRect();
      var pointerOnThumb = event.clientX >= thumbRect.left && event.clientX <= thumbRect.right;
      pointerGrabOffset = pointerOnThumb ? event.clientX - thumbRect.left : metrics.thumbWidth / 2;

      if (track.setPointerCapture) track.setPointerCapture(activePointerId);
      track.classList.add('is-dragging');
      setScrollFromPointer(event.clientX);
    });

    track.addEventListener('pointermove', function (event) {
      if (event.pointerId !== activePointerId) return;
      event.preventDefault();
      setScrollFromPointer(event.clientX);
    });
    track.addEventListener('pointerup', endTrackDrag);
    track.addEventListener('pointercancel', endTrackDrag);

    track.addEventListener('keydown', function (event) {
      if (isDesktopSwatchLayout()) return;

      var amount = Math.max(slider.clientWidth * 0.25, 80);
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        slider.scrollBy({ left: -amount, behavior: 'smooth' });
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        slider.scrollBy({ left: amount, behavior: 'smooth' });
      } else if (event.key === 'Home') {
        event.preventDefault();
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (event.key === 'End') {
        event.preventDefault();
        slider.scrollTo({ left: slider.scrollWidth, behavior: 'smooth' });
      }
    });

    if (toggleButton) {
      toggleButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (toggleButton.hidden || !isDesktopSwatchLayout()) return;

        group.classList.toggle('is-collapsed');
        userPreferredCollapsed = group.classList.contains('is-collapsed');
        updateDesktopLayoutState();
      });
    }

    if (prevNavButton) {
      prevNavButton.addEventListener('click', function (event) {
        event.preventDefault();
        slider.scrollBy({ left: -Math.max(slider.clientWidth * 0.7, 140), behavior: 'smooth' });
      });
    }

    if (nextNavButton) {
      nextNavButton.addEventListener('click', function (event) {
        event.preventDefault();
        slider.scrollBy({ left: Math.max(slider.clientWidth * 0.7, 140), behavior: 'smooth' });
      });
    }

    if (summaryEl) {
      summaryEl.addEventListener('click', function (event) {
        if (isDesktopSwatchLayout()) event.preventDefault();
      });
    }

    updateDesktopLayoutState();
  }

  function initAllSliders(root) {
    (root || document).querySelectorAll('[data-swatch-slider]').forEach(function (slider) {
      if (slider.closest('[data-more-style-swatches-panel][hidden]')) return;
      initSlider(slider);
    });
  }

  document.addEventListener('click', function (event) {
    var toggleButton = event.target.closest('[data-more-style-swatches-toggle]');
    if (!toggleButton) return;

    var wrapper = toggleButton.closest('[data-more-style-swatches]');
    var panel = wrapper ? wrapper.querySelector('[data-more-style-swatches-panel]') : null;
    if (!panel) return;

    event.preventDefault();

    var isExpanded = !panel.hidden;
    var moreText = toggleButton.getAttribute('data-more-text') || 'Click to view more styles';
    var lessText = toggleButton.getAttribute('data-less-text') || 'Click to view less';

    panel.hidden = isExpanded;
    wrapper.classList.toggle('is-expanded', !isExpanded);
    toggleButton.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    toggleButton.textContent = isExpanded ? moreText : lessText;

    if (!isExpanded) {
      window.requestAnimationFrame(function () {
        initAllSliders(panel);
      });
    }
  });

  document.addEventListener('theme:product-loaded', function () {
    window.requestAnimationFrame(function () {
      initAllSliders();
    });
  });

  window.ProductSwatches = {
    centerActive: centerActive,
    initSlider: initSlider,
    initAllSliders: initAllSliders,
  };

  window.dispatchEvent(new CustomEvent('product-swatches:ready'));
})();
